import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        PAYMENT_AFTER_APPLYING: 'PAYMENT_AFTER_APPLYING',
        PAYMENT_AFTER_EMISSION: 'PAYMENT_AFTER_EMISSION',
      },
    }
  }
}